import { useSelector } from 'react-redux';
import { NewTabLink } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { getPlatformPrimaryUrl } from '../../../../modules/app/reducers/configuration';

interface PlatformLinkProps {
    textKey: Mews.TextKey;
    url: string;
    inherit?: boolean;
}

const PlatformLink: React.FC<PlatformLinkProps> = ({ url, textKey, ...other }) => {
    const platformPrimaryUrl = useSelector(getPlatformPrimaryUrl);

    return (
        <NewTabLink url={`${platformPrimaryUrl}${url}`} {...other}>
            <LocalizedText textKey={textKey} />
        </NewTabLink>
    );
};

export default PlatformLink;
